export default defineNuxtRouteMiddleware(() => {
  const { loggedIn } = useUserSession()

  // redirect the user to the personal data screen if they were authenticated
  if (loggedIn.value) {
    return navigateTo('/my-account/my-dashboard')
  }
});
